import AddBrandForm from 'components/brand/addBrandForm';
import CommonLayout from 'layouts/DashboardLayout';
import React from 'react';

export default function AddBrand() {
  return (
    <CommonLayout>
      <AddBrandForm />
    </CommonLayout>
  );
}
